export function getFileIcon(fileType: string | null | undefined): string {
    if (!fileType) return 'text.svg'; // Default icon if fileType is undefined or null

    if (fileType === 'application/pdf') {
        return 'pdf.svg';
    } else if (fileType.includes('word')) {
        return 'doc.svg';
    } else if (fileType.includes('javascript')) {
        return 'js.svg';
    } else if (fileType.includes('text/plain')) {
        return 'text.svg';
    } else {
        return 'text.svg'; // Default icon for unrecognized file types
    }
}
